import Modal from "bootstrap/js/dist/modal";
import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", () => {
    const c = {
        "AF": 'Afghanistan',
        "AL": 'Albania',
        "DZ": 'Algeria',
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AR": "Argentina",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BZ": "Belize",
        "CC": "Cocos (Keeling) Islands",
        "CD": "Congo (Kinshasa)",
        "CF": "Central African Republic",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CV": "Cape Verde",
        "CX": "Christmas Island",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GF": "French Guiana",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GP": "Guadeloupe",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GS": "South Georgia and the South Sandwich Islands",
        "GT": "Guatemala",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IS": "Iceland",
        "IT": "Italy",
        "JM": "Jamaica",
        "JO": "Jordan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KR": "Republic of Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MK": "Macedonia",
        "ML": "Mali",
        "MN": "Mongolia",
        "MO": "Macao",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NF": "Norfolk Island",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn",
        "PS": "Palestinian Territory",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SS": "South Sudan",
        "ST": "Sao Tome and Principe",
        "SV": "El Salvador",
        "SZ": "Swaziland",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TF": "French Southern Territories",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor-Leste",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    }

    const userLangFull = navigator.language;
    const userLang = userLangFull.split('-')[0];
    // let userLang = userLangFull.split('-')[0];
    const country_code = GEOIP.country || '';
    let _country_undefined_flag = false;

    let is_fynxt = false;
    const partner_cookie =Cookies.get('agent[agent_id]');
    const urlParams = new URLSearchParams(window.location.search);
    if ('undefined' !== typeof partner_cookie && partner_cookie.length > 0) {
      is_fynxt = true;
    } else {
      for (const [key, value] of urlParams) {
        if (-1 !== ['referral', 'formx', 'Referral', 'Formx'].indexOf(key)) {
          is_fynxt = true;
        }
      }
    }

   //@todo: remove after QA!
    // userLang = 'xx'; /// test
    console.log("language: ", userLang);
    console.log("country_code: ", country_code);
    // console.log("is_fynxt: ", is_fynxt);

    const changeModalTitle = () => {
        let country = GEOIP.country || '';
        if (typeof c[country] !== "undefined") {
            country = c[country];
        } else {
          _country_undefined_flag = true;
        }

        switch (userLang) {
          case 'es':
            country = 'Spanish';
            break;
          case 'ar':
            country = 'Arabic';
            break;
        }

        let title = document.getElementById("RedirectModalLabel").innerText.replace('[COUNTRY]', country);
        let body = document.getElementById("RedirectModalBody").innerText.replace('[COUNTRY]', country);
        let yesBtn = document.getElementById("RedirectModalYesButton").innerText.replace('[COUNTRY]', country);

        if (_country_undefined_flag) {
          title = 'Trying to access FXTM?';
          body = 'Sorry this website isn’t available in your region. If you’d like to open an account with us, please click the link below.';
          yesBtn = 'Continue';
        }

        if(country_code === 'HK') {
          title = 'Important Notice for Visitors from Hong Kong';
          body = 'The products and services on this website are not intended for individuals in Hong Kong. Nothing on this website is intended to be construed as a solicitation of any individual in Hong Kong.';
          yesBtn = 'I understood';
        }

        switch (userLang) {
          case 'es':
            title = '¿Buscas nuestro sitio web en español?';
            body = 'Lo sentimos, este contenido no está disponible en su región. Si desea abrir una cuenta con nosotros, haga click en el siguiente enlace para visitar nuestro sitio web en español.';
            yesBtn = 'Continuar a la web en español';
            break;
          case 'ar':
            title = 'هل تبحث عن موقعنا باللغة العربية؟';
            body = 'عذرًا، لا يتوفر هذا المحتوى في منطقتك. إذا كنت ترغب في فتح حساب معنا، فيرجى الضغط على الرابط بالأسفل لزيارة موقعنا باللغة العربية.';
            yesBtn = 'الانتقال إلى موقعنا باللغة العربية';
            break;
        }
        document.getElementById("RedirectModalLabel").innerHTML = title;
        document.getElementById("RedirectModalBody").innerHTML = body;
        document.getElementById("RedirectModalYesButton").innerHTML = yesBtn;
        if ('ar' === userLang) {
          document.getElementById("RedirectModalBody").style.direction = 'rtl';
        }
    }

    const myModalEl = document.getElementById('RedirectModal');
    myModalEl.addEventListener('show.bs.modal', function () {
        changeModalTitle();
    });

    document.getElementById('RedirectModal').addEventListener('hidden.bs.modal', function () {
        sessionStorage.setItem("modalClosed", "true"); // Store closed state
    });

    //***************************
    let _redirect = false;
    if ('en' === userLang) {
        if ('IN' === country_code && !is_fynxt) {
          _redirect = drupalSettings.fxi_redirect.country[country_code];
        } else {
          if (['GB', 'CN', 'TW', 'MO', 'TH'].indexOf(country_code) !== -1) {
            _redirect = drupalSettings.fxi_redirect.country[country_code];
          } else {
            if (['VN', 'MY', 'ID', 'KR', 'IN'].indexOf(country_code) === -1) {
              _redirect = drupalSettings.fxi_redirect.language[userLang];
            }
            if ('ar' === drupalSettings.fxi_redirect.currentLanguage) {
              _redirect = drupalSettings.fxi_redirect.language['ar'];
            }
          }
        }
    } else {
        if (['zh-HK', 'zh-TW', 'zh-MO', 'zh-CN'].indexOf(userLangFull) !== -1) {
          _redirect = drupalSettings.fxi_redirect.language[userLangFull.toLowerCase()];
        } else {
          if (['hi', 'te', 'ta', 'ml', 'mr', 'gu', 'kn', 'bn'].indexOf(userLang) !== -1 && !is_fynxt) {
            _redirect = drupalSettings.fxi_redirect.language[userLang];
          } else {
            if (['es', 'ar', 'th', 'zh'].indexOf(userLang) !== -1) {
              _redirect = drupalSettings.fxi_redirect.language[userLang];
            } else {
              _redirect = drupalSettings.fxi_redirect.language['en'];
            }
          }
        }
    }

    //@todo: remove after QA!
    console.log(_redirect);

    if (typeof Modal !== "undefined") {
        if ((_redirect || country_code === 'HK')  && !sessionStorage.getItem("modalClosed")) {
            const myModal = new Modal(document.getElementById('RedirectModal'));
            myModal.show();

            document.getElementById("RedirectModalYesButton").addEventListener("click", function () {
                if(country_code === 'HK') {
                  myModal.hide();
                } else if (_redirect) {
                    let g = "";
                    function getCookie(r){return document.cookie.split("; ").reduce(((e,t)=>{const[a,n]=t.split("=");return a===r?decodeURIComponent(n):e}),null)}function getURLParameter(r){return new URLSearchParams(window.location.search).get(r)}const referralParam=getURLParameter("Referral"),formxParam=getURLParameter("Formx"),subId=getURLParameter("sub_id");if(referralParam)g=`?Referral=${referralParam}`,subId&&(g+=`&sub_id=${subId}`);else if(formxParam)g=`?Formx=${formxParam}`,subId&&(g+=`&sub_id=${subId}`);else{const r=getCookie("user_partners");if(r)try{const e=JSON.parse(r);e.id&&"fynxt_partner"===e.type?g=/^\d+$/.test(e.id)?`?Referral=${e.id}`:`?Formx=${e.id}`:e.fynxt_partner&&e.fynxt_partner.current?g=/^\d+$/.test(e.fynxt_partner.current)?`?Referral=${e.fynxt_partner.current}`:`?Formx=${e.fynxt_partner.current}`:e.id&&"partner_id"===e.type&&(g=/^\d+$/.test(e.id)?`?partner_id=${e.id}`:`?form=${e.id}`),e.sub_id&&(g+=`&sub_id=${e.sub_id}`)}catch(r){console.warn("Invalid cookie format:",r)}}

                    if (window.document.referrer !== "") document.cookie = "fxtmreferer=" + window.document.referrer + ";path=/";
                    _redirect = _redirect + g + location.hash;
                    //@todo: remove after QA!
                    console.log("Redirect to: ", _redirect);
                    sessionStorage.setItem("modalClosed", "true"); // Store closed state
                    window.location.href = _redirect;
                }
                myModal.hide();
            });
        }

    } else {
        console.error("Bootstrap JS is not loaded!");
    }

});